window.onload = function(){
  var linkmsg=document.getElementById("linkmsg");
  linkmsg.style.visibility="hidden";
  sizemsg.style.visibility="hidden";
  document.getElementById("material").innerHTML = "選択してください";
  document.getElementById("width").value="";
  document.getElementById("height").value="";
  document.getElementById("price").value="";
  document.getElementById("grip").innerHTML = "選択してください";
  document.getElementById("leg").innerHTML = "選択してください";

  var cancel = document.querySelectorAll(`input[type='radio']`);
  for (const i of cancel) {i.checked = false;}
  var cancel2 = document.querySelectorAll(`input[type='checkbox']`);
  for (const i of cancel2) {i.checked = false;}
  cartReset();resizing();
};
window.onresize = function(){resizing();};

// プルダウンメニューから選択した値に基づいて画像のURLを変更する関数
function changeSize() {
  // 選択されたheightの値を取得
  var height = document.getElementById("height").value;
  
  // heightの値に基づいてimgHを設定。値が2から5の範囲外の場合はデフォルト値"452"を使用
  var imgH = (height >= 2 && height <= 5) ? "45" + height : "452";
  
  // area2とarea3の画像URLを変更する処理を行う関数
  function changeImageUrl(area) {
    var changeImgUrl = $(document[area]).attr("src").split("/");
    changeImgUrl[9] = imgH;
    var newImgUrl = changeImgUrl.join("/");
    $(document[area]).attr("src", newImgUrl);
  }

//高さ矢印//
  var imgArrow = "mc45_size_";
  var changeArrow = imgArrow+imgH;
  var changeArrowImgUrl = $(document.area1).attr("src").split("/");
  var changeArrowImgUrl = $(document.area1).attr("src").replace(changeArrowImgUrl[8] , changeArrow);
  $(document.area1).attr("src", changeArrowImgUrl+".png");

  
  // area2とarea3の画像URLを変更
  changeImageUrl("area2");
  changeImageUrl("area3");

}//changeSize()の動作終了



//カート中身リセット
function cartReset(){
    document.getElementById("price").value="";
    cart_price.innerHTML =""+" 円";
    cart_width.innerHTML=""; 
    cart_height.innerHTML=""; 
    cart_color.innerHTML="";
    color_grip.innerHTML="";
    color_leg.innerHTML="";

    linkmsg.style.visibility="hidden";
}

//リアルタイムサイズチェック
function changeMsg(){
    var intWidth=document.getElementById("width").value;
    sizemsg.style.visibility="hidden";
    cartReset();
    if (intWidth==""){
        document.getElementById("sizemsg").innerHTML = "<p> </p>";
     sizemsg.style.visibility="hidden";
        return false;
    }
    if (intWidth < 30 || intWidth > 60){document.getElementById("sizemsg").innerHTML = "<p>※ 幅30cm未満・幅60cm以上はオーダー不可です ※</p>";sizemsg.style.visibility="visible";return false;}
    document.getElementById("sizemsg").innerHTML = "<p> </p>";
    
 sizemsg.style.visibility="hidden";
}

//材質切替
function materialWood(){document.getElementById("material").innerHTML = "リーズナブル木目：<br class=\"delete\">[材質]プリント化粧合板";}
function materialAino(){document.getElementById("material").innerHTML = "パステルカラーaino：<br class=\"delete\">[材質]プリント化粧合板";}
function materialMela(){document.getElementById("material").innerHTML = "ハイグレード鏡面仕上げ：<br>[本体]メラミン樹脂化粧合板 <br class=\"delete\">[背板]プリント化粧合板";}


function colorMain(changeImg) {
  let imgMain = document.querySelector("[name='area3']");

  // IDから直接色を取得
  let selectedColor = document.getElementsByName("color_main")[changeImg].id.split("_")[1];

  let imgColor = $(imgMain).attr("src").split("/");
  imgColor[10] = selectedColor + ".png"; // 10番目の要素を更新
  let newImgUrl = imgColor.join("/");
  $(imgMain).attr('src', newImgUrl);
}


function grip(changeImg) {
  let imgGrip = document.querySelector("[name='area2']");

  // IDから直接色を取得
  let selectedColor = document.getElementsByName("color_grip")[changeImg].id.split("_")[1];// "_"以降の文字列を取得。

  let imgColor = $(imgGrip).attr("src").split("/");
  imgColor[10] = selectedColor + ".png";
  let newImgUrl = imgColor.join("/");
  $(imgGrip).attr('src', newImgUrl);
}

function leg(changeImg) {
  let imgLeg = document.querySelector("[name='area4']");

  // IDから直接色を取得
  let selectedColor = document.getElementsByName("color_leg")[changeImg].id.split("_")[1];

  let imgColor = $(imgLeg).attr("src").split("/");
  imgColor[9] = selectedColor + ".png";
  let newImgUrl = imgColor.join("/");
  $(imgLeg).attr('src', newImgUrl);
}




//サイズオーダー
const strLink1="<a href=\"https://interior-arne.com/products/";
const strLink2="\" target=\"_blank\">→こちらのページよりお買い求めください。</a>";

function setGoods(url,width,height,color,grip,leg){
this.url=url;this.width=width;this.height=height;this.color=color;this.grip=grip;this.leg=leg;}

function searchURL(strWidth,strHeight,strColor,valueGrip,valueLeg){
  var strErr;
  var intWidth=document.getElementById("width").value;
  var intHeight=document.getElementById("height").value;

  //サイズチェック
  if (intWidth < 30 || intWidth > 60){strErr="幅30cm未満・幅60cm以上は";}
  if(strErr){document.getElementById("price").value="";
  return strErr+"オーダー不可です。";}

  //幅サイズ成形
  switch(intWidth != null){
    case intWidth <= 45: priceH = 0;break;
    case intWidth <= 60: priceH = 1;break;
  }

  //段数サイズ成形
  switch(intHeight != null){
    case intHeight <= 2: priceW = 0;break;
    case intHeight <= 3: priceW = 1;break;
    case intHeight <= 4: priceW = 2;break;
    case intHeight <= 5: priceW = 3;break;
  }

    var arr = csvToArray("https://cdn.shopify.com/s/files/1/0549/1834/8887/files/mc45_price.csv?v=1737701967");
    if(strColor == "aino"){priceW=priceW+4;}
    else if(strColor == "mela_nail" || strColor == "mela_black"){priceW=priceW+8;}
    else if(strColor == "mela_bp"){priceW=priceW+12;}
    else if(strColor == "mela_gs" || strColor == "mela_mb" || strColor == "mela_ww"){priceW=priceW+16;}
    var sellPrice = arr[priceH][priceW];
    return sellPrice;

  function csvToArray(filename) {

    var srt = new XMLHttpRequest();
    srt.open("GET", filename, false);
    try {
      srt.send(null);
    } catch (err) {
      console.log(err);
    }
    var csvArr = [];
    var lines = srt.responseText.split("\n");
    for (var i = 0; i < lines.length; ++i) {
      var cells = lines[i].split(",");
      if (cells.length != 1) {
        csvArr.push(cells);
      }
    }
    return csvArr;
  }
  
}


/*リストから商品URLを取得*/
function checkURL(strWidth,strHeight,strColor,valueGrip,valueLeg){
switch(true){
 default:
  for(var i in goods){
if(goods[i].width==strWidth && goods[i].height==strHeight && goods[i].color==strColor&& goods[i].grip==valueGrip&& goods[i].leg==valueLeg){
return goods[i].url;}}
  break;
return false;
}
}
// 数値チェック
function isNumber(numVal){
  var pattern =/^([1-9]\d*|0)$/;
  return pattern.test(numVal);
}
/*価格算出ボタン押下時*/
function jump(){
cartReset();
    
var linkmsg=document.getElementById("linkmsg");
linkmsg.innerHTML="";
linkmsg.style.visibility="hidden";
var ErrMsg=document.getElementById("linkmsg");
ErrMsg.innerHTML="";
document.getElementById("price").value="";

var strWidth=document.getElementById("width").value;
var strHeight=document.getElementById("height").value;
var idColor = document.getElementsByName("color_main") ;
var idGrip = document.getElementsByName("color_grip") ;
var idLeg = document.getElementsByName("color_leg") ;
var strColor = "";
var strGrip = "";
var strLeg = "";
var i=0;
var c=0;
for ( strColor="", i=idColor.length; i--; ) {
 if ( idColor[i].checked ) {
     if( idColor[i].id.slice(0,4)=="aino" ){
         strColor = idColor[i].id.slice(0,4);
     }else{
         strColor = idColor[i].id;
     }
  var valueColor = idColor[i].value ;
  break ;
 }
}

for ( strGrip="", c=idGrip.length; c--; ) {
 if ( idGrip[c].checked ) {
  strGrip = idGrip[c].id ;
  var valueGrip = idGrip[c].value ;
  break ;
 }
}

for ( strLeg="", c=idLeg.length; c--; ) {
 if ( idLeg[c].checked ) {
  strLeg = idLeg[c].id ;
  var valueLeg = idLeg[c].value ;
  break ;
 }
}


if (isNumber(strWidth)==false){
alert("幅は『1以上の整数(小数点不可/半角文字）』をご入力ください。");
return false;
}
if (strColor==false){
alert("カラーを選択してください");
return false;
}
if (strHeight==false){
alert("段数を選択してください");
return false;
}

//ラジオボタン中身の取得
var isGripSelected = false;
for (var i = 0; i < idGrip.length; i++) {
  if (idGrip[i].checked) {
    isGripSelected = true;
    break;
  }
}

var idLegSelected = false;
for (var i = 0; i < idLeg.length; i++) {
  if (idLeg[i].checked) {
    idLegSelected = true;
    break;
  }
}

//取っ手の未選択エラー表示
if (!isGripSelected) {
  alert("取っ手カラーを選択してください");
  return false;
}

//脚の未選択エラー表示

if (!idLegSelected) {
  alert("脚カラーを選択してください");
  return false;
}

document.getElementById("choice1").value=strWidth+"cm";
document.getElementById("choice2").value=strHeight+"段";
document.getElementById("choice3").value="40.8cm";
document.getElementById("choice4").value=valueColor+"";
document.getElementById("choice5").value=valueLeg+"";
document.getElementById("choice6").value=valueGrip+"";


//商品ページの有無チェック
var comcode=checkURL(strWidth,strHeight,strColor,valueGrip,valueLeg);
if (!comcode==""){
  var target=document.getElementById("linkmsg");
  linkmsg.style.visibility="visible";
  target.innerHTML="ご希望サイズは既製品がございます。<br>"+strLink1+comcode+"/"+strLink2;
  return false;
}
var url=searchURL(strWidth,strHeight,strColor,valueGrip,valueLeg);


if(!url){
alert("幅、段数を選んでください");
return false;
}


var intUnit;
if (isNaN(url)==false){
 intUnit=(parseInt(url))/1000;
 document.getElementById("price").value =(parseInt(url)).toLocaleString()+" 円";
 cart_price.innerHTML =(parseInt(url)).toLocaleString()+" 円";
 cart_width.innerHTML=strWidth;
 cart_height.innerHTML=strHeight;
 cart_color.innerHTML=valueColor;
 color_grip.innerHTML=valueGrip;
 color_leg.innerHTML=valueLeg;

}
else if(isNaN(url)==true) {
linkmsg.style.visibility="visible";
 ErrMsg.innerHTML=url;
 intUnit=""
}
document.getElementById("units").value=intUnit;
document.getElementById("choice7").value="見積もり金額："+(parseInt(url));
return false;
}



function checkText() {
 var choice1=document.frm.choice1.value;
 var choice2=document.frm.choice2.value;
 var choice3=document.frm.choice3.value;
 var choice4=document.frm.choice4.value;
 var choice5=document.frm.choice5.value;
 var choice6=document.frm.choice6.value;
 var text = document.frm.inventory_id.value;
 var price = document.frm_detail.price.value;
 if(choice1=="" || choice2=="" || choice3=="") {
     alert("ご希望のサイズを正しく入力後、価格算出ボタンを押してください。");
     return false;
 }
 if(price=="") {
     alert("価格が算出されていません。既製品がある場合、「この条件で金額算出」ボタン下の該当商品ページよりお買い求めください。");
     return false;
 }       
 return true;
}


//既存ページ
goods = new Object();
goods[0] =new setGoods("0000a39446","45","2","aino","グレー","グレー");
goods[1] =new setGoods("0000a39452","45","3","aino","グレー","グレー");
goods[2] =new setGoods("0000a39458","45","4","aino","グレー","グレー");
goods[3] =new setGoods("0000a39464","45","5","aino","グレー","グレー");
goods[4] =new setGoods("0000a54984","45","2","mela_nail","ホワイト","ホワイト");
goods[5] =new setGoods("0000a54985","45","3","mela_nail","ホワイト","ホワイト");
goods[6] =new setGoods("0000a54986","45","4","mela_nail","ホワイト","ホワイト");
goods[7] =new setGoods("0000a54987","45","5","mela_nail","ホワイト","ホワイト");
goods[8] =new setGoods("0000a54988","45","2","mela_black","ブラック","ブラック");
goods[9] =new setGoods("0000a54989","45","3","mela_black","ブラック","ブラック");
goods[10] =new setGoods("0000a54990","45","4","mela_black","ブラック","ブラック");
goods[11] =new setGoods("0000a54991","45","5","mela_black","ブラック","ブラック");
goods[12] =new setGoods("0000a54992","45","2","mela_bp","ブラック","ブラック");
goods[13] =new setGoods("0000a54993","45","3","mela_bp","ブラック","ブラック");
goods[14] =new setGoods("0000a54994","45","4","mela_bp","ブラック","ブラック");
goods[15] =new setGoods("0000a54995","45","5","mela_bp","ブラック","ブラック");
goods[16] =new setGoods("0000a54996","45","2","mela_mb","ホワイト","ホワイト");
goods[17] =new setGoods("0000a54997","45","3","mela_mb","ホワイト","ホワイト");
goods[18] =new setGoods("0000a54998","45","4","mela_mb","ホワイト","ホワイト");
goods[19] =new setGoods("0000a54999","45","5","mela_mb","ホワイト","ホワイト");
goods[20] =new setGoods("0000a55000","45","2","mela_gs","ホワイト","ホワイト");
goods[21] =new setGoods("0000a55001","45","3","mela_gs","ホワイト","ホワイト");
goods[22] =new setGoods("0000a55002","45","4","mela_gs","ホワイト","ホワイト");
goods[23] =new setGoods("0000a55003","45","5","mela_gs","ホワイト","ホワイト");
goods[24] =new setGoods("0000a55004","45","2","mela_ww","ホワイト","ホワイト");
goods[25] =new setGoods("0000a55005","45","3","mela_ww","ホワイト","ホワイト");
goods[26] =new setGoods("0000a55006","45","4","mela_ww","ホワイト","ホワイト");
goods[27] =new setGoods("0000a55007","45","5","mela_ww","ホワイト","ホワイト");
goods[28] =new setGoods("0000ae021865","45","2","wood_br","ブラック","ブラック");
goods[29] =new setGoods("0000ae021865","45","2","wood_dbr","ブラック","ブラック");
goods[30] =new setGoods("0000ae021865","45","2","wood_wh","ホワイト","ホワイト");
goods[31] =new setGoods("0000ae021865","45","2","wood_tk","ブラック","ブラック");
goods[32] =new setGoods("0000ae021865","45","2","wood_ntr","ホワイト","ホワイト");
goods[33] =new setGoods("0000ae021865","45","2","wood_whw","ホワイト","ホワイト");
goods[34] =new setGoods("0000ae021865","45","2","wood_oak","ブラック","ブラック");
goods[35] =new setGoods("0000ae021865","45","2","wood_bkw","ブラック","ブラック");
goods[36] =new setGoods("0000ae021873","45","3","wood_br","ブラック","ブラック");
goods[37] =new setGoods("0000ae021873","45","3","wood_dbr","ブラック","ブラック");
goods[38] =new setGoods("0000ae021873","45","3","wood_wh","ホワイト","ホワイト");
goods[39] =new setGoods("0000ae021873","45","3","wood_tk","ブラック","ブラック");
goods[40] =new setGoods("0000ae021873","45","3","wood_ntr","ホワイト","ホワイト");
goods[41] =new setGoods("0000ae021873","45","3","wood_whw","ホワイト","ホワイト");
goods[42] =new setGoods("0000ae021873","45","3","wood_oak","ブラック","ブラック");
goods[43] =new setGoods("0000ae021873","45","3","wood_bkw","ブラック","ブラック");
goods[44] =new setGoods("0000ae021881","45","4","wood_br","ブラック","ブラック");
goods[45] =new setGoods("0000ae021881","45","4","wood_dbr","ブラック","ブラック");
goods[46] =new setGoods("0000ae021881","45","4","wood_wh","ホワイト","ホワイト");
goods[47] =new setGoods("0000ae021881","45","4","wood_tk","ブラック","ブラック");
goods[48] =new setGoods("0000ae021881","45","4","wood_ntr","ホワイト","ホワイト");
goods[49] =new setGoods("0000ae021881","45","4","wood_whw","ホワイト","ホワイト");
goods[50] =new setGoods("0000ae021881","45","4","wood_oak","ブラック","ブラック");
goods[51] =new setGoods("0000ae021881","45","4","wood_bkw","ブラック","ブラック");
goods[52] =new setGoods("0000ae021889","45","5","wood_br","ブラック","ブラック");
goods[53] =new setGoods("0000ae021889","45","5","wood_dbr","ブラック","ブラック");
goods[54] =new setGoods("0000ae021889","45","5","wood_wh","ホワイト","ホワイト");
goods[55] =new setGoods("0000ae021889","45","5","wood_tk","ブラック","ブラック");
goods[56] =new setGoods("0000ae021889","45","5","wood_ntr","ホワイト","ホワイト");
goods[57] =new setGoods("0000ae021889","45","5","wood_whw","ホワイト","ホワイト");
goods[58] =new setGoods("0000ae021889","45","5","wood_oak","ブラック","ブラック");